export default __webpack_public_path__ + "img/dc32039f04ea22ab460e761320b5b7fb.svg";